import { Box, useTheme } from '@material-ui/core';
import { Backdrop, Switch } from '@room-match/shared-ui-components';
import { useState, Fragment } from 'react';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { useEditProfileCompositeCardData } from '../../hooks/useEditProfileCompositeCardData';
import { CompCardContainer, compositeCardStyles } from './EditProfileMediaCompositeCard.styles';
import { useEditProfileCompositeCardMutation } from '../../hooks/useEditProfileCompositeCardMutation';
import MediaBinModal from 'shared/components/MediaBinModal/MediaBinModal';
import AsyncCompositeCard from 'components/AsyncCompositeCard/AsyncCompositeCard';
import React from 'react';
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog';
import EditCompCardInfo from './EditCompCardInfo';

const EditProfileMediaCompositeCard = () => {
  const queryClient = useQueryClient();
  const theme = useTheme();
  const themeType = theme.palette.type;
  const styles = compositeCardStyles(theme);
  const { id: profileId } = useParams() as { id: string };
  const [showEditInfo, setShowEditInfo] = useState(false);

  const {
    profileInfo,
    compositeCardData,
    isLoadingCompositeCardData,
    finalTalentInfo,
    getMediaProfile,
    getSingleProfile,
    getProfileTabDetail,
    getStatistics,
    getGeneral,
    getMediaList,
  } = useEditProfileCompositeCardData(profileId);

  const {
    updateProfile,
    ConfirmationModal,
    handleClick,
    toggleEnable,
    isConfirmModalOpen,
    handleSave,
    uploadMedia,
    isInitialCompositeDataIsNull,
    isLoadingUpdateProfile,
  } = useEditProfileCompositeCardMutation({
    profileId,
    compositeCardData,
    profileInfo,
    setShowEditInfo,
  });

  const compositeCardProps = {
    profileId,
    compositeCardData: compositeCardData,
    isLoadingCompositeCardData,
    queryClient: queryClient,
    uploadMedia: uploadMedia,
    getMediaList: getMediaList,
    getMediaProfile: getMediaProfile,
    getSingleProfile: getSingleProfile,
    updateProfile: updateProfile,
    getStatistics: getStatistics,
    getGeneral: getGeneral,
    getProfileTabDetail: getProfileTabDetail,
    theme: themeType,
    mediaBinModalComponent: MediaBinModal,
    editInfo: () => setShowEditInfo(true),
  };

  return (
    <Fragment>
      {isConfirmModalOpen && <ConfirmationModal onConfirm={() => setShowEditInfo(false)} />}
      <Backdrop isLoading={isLoadingUpdateProfile || isInitialCompositeDataIsNull} />
      <CompCardContainer>
        <AsyncCompositeCard {...compositeCardProps} finalTalentInfo={finalTalentInfo()} />
        <Box sx={styles.switchWrapper}>
          <Switch
            disabled={isLoadingCompositeCardData}
            toggle={toggleEnable}
            checked={compositeCardData?.data.attributes.composite_card?.enabled}
          />
          <Box sx={styles.switchTitle}>
            {compositeCardData?.data.attributes.composite_card?.enabled ? 'Enabled' : 'Disabled'}
          </Box>
        </Box>
        {showEditInfo ? (
          <StyledDialog open={showEditInfo} maxWidth="lg" fullWidth>
            <EditCompCardInfo
              handleSave={handleSave}
              onClose={handleClick}
              info={compositeCardData?.data.attributes.composite_card?.info || []}
            />
          </StyledDialog>
        ) : (
          <React.Fragment />
        )}
      </CompCardContainer>
    </Fragment>
  );
};

export default EditProfileMediaCompositeCard;
